import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const eyeIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.19556 10.2687C2.13799 10.0959 2.13794 9.90895 2.1954 9.73619C3.35237 6.2581 6.63326 3.75 10.4999 3.75C14.3648 3.75 17.6445 6.25577 18.8029 9.73134C18.8604 9.90406 18.8605 10.0911 18.803 10.2638C17.6461 13.7419 14.3652 16.25 10.4985 16.25C6.6336 16.25 3.35397 13.7442 2.19556 10.2687Z"
      stroke="#0F172A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.9993 10C12.9993 11.3807 11.88 12.5 10.4993 12.5C9.11856 12.5 7.99927 11.3807 7.99927 10C7.99927 8.61929 9.11856 7.5 10.4993 7.5C11.88 7.5 12.9993 8.61929 12.9993 10Z"
      stroke="#0F172A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const EyeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={eyeIcon} {...props} />
);
